import { Navigate, Outlet, useLocation } from "react-router-dom";
interface Props {
    children?: JSX.Element ;
    authed: boolean;
}

const PrivateRoutes = ({ authed, children }: Props) => {
    let location = useLocation();

    if(!authed) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return  <Outlet />
};

export default PrivateRoutes;
